import { useMemo } from 'react';
import {
  getContactEmail,
  getTelegramUrl,
  getWhatsappUrl,
} from './runtimeConfig';

export interface CommunityLinks {
  whatsappUrl: string;
  telegramUrl: string;
  contactEmail: string;
}

/** Community footer / menu links from runtime-config.js or CRA env. */
export function useCommunityLinks(): CommunityLinks {
  return useMemo(
    () => ({
      whatsappUrl: getWhatsappUrl(),
      telegramUrl: getTelegramUrl(),
      contactEmail: getContactEmail(),
    }),
    []
  );
}
